import PropTypes from 'prop-types';

// Keep in sync with benchling/exports/human_exports/app/notebook.py:export_entry
export default interface EntryExportConfig {
  showBranding?: boolean;
  showReviewHistory?: boolean;
  showReviewCommentHistory?: boolean;
  exportedOn?: string;

  // Should always be true unless we are working with paginated exports after the first portion
  showEntryTitle?: boolean;

  // Should we show the first section header within the indexSlice that we're printing. This would be false if
  // we are paginating our exports and the section header would have been repeated across a new section.
  showFirstSectionHeader?: boolean;
  showGeneratedOnTimestamp?: boolean;
}

export const EntryExportConfigShape = {
  showBranding: PropTypes.bool,
  showReviewHistory: PropTypes.bool,
  showReviewCommentHistory: PropTypes.bool,
  exportedOn: PropTypes.string,
  showEntryTitle: PropTypes.bool,
  showFirstSectionHeader: PropTypes.bool,
  showGeneratedOnTimestamp: PropTypes.bool,
};
